(() => {
  const parseJSON = (element) => {
    const script = element.querySelector('[data-pickup-availability-variants]');

    if (!script) return {};

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  };

  class ProductPickupAvailability extends HTMLElement {
    connectedCallback() {
      this.variantData = parseJSON(this);
      this.status = this.querySelector('[data-pickup-availability-status]');
      this.list = this.querySelector('[data-pickup-availability-list]');
      this.onVariantChange = this.onVariantChange.bind(this);

      document.addEventListener('product:variant-change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      const eventScope = event.detail && event.detail.scope;

      if (!variant) return;
      if ((eventScope || this.scope) && eventScope !== this.scope) return;

      this.renderVariant(variant.id);
    }

    get scope() {
      return this.dataset.productUiScope || this.closest('.product-layout, .featured-product-showcase, [data-search-product-drawer]') || '';
    }

    renderVariant(variantId) {
      const data = this.variantData[String(variantId)];

      if (!data || !Array.isArray(data.locations) || data.locations.length === 0) {
        this.hidden = true;
        return;
      }

      const availableLocations = data.locations.filter((location) => location.available);
      this.hidden = false;

      if (this.status) {
        this.status.textContent =
          availableLocations.length > 0 ? data.labels.available : data.labels.unavailable;
      }

      if (this.list) {
        this.list.innerHTML = data.locations.map((location) => this.renderLocation(location)).join('');
      }
    }

    renderLocation(location) {
      const status = location.message || (location.available ? location.pickUpTime : location.unavailableText);
      const statusClass = location.available ? 'is-available' : 'is-unavailable';

      return `
        <li class="product-pickup-availability__location ${statusClass}">
          <span class="product-pickup-availability__location-name">${this.escapeHTML(location.name)}</span>
          <span class="product-pickup-availability__location-status">${this.escapeHTML(status)}</span>
        </li>
      `;
    }

    escapeHTML(value) {
      const span = document.createElement('span');
      span.textContent = value || '';
      return span.innerHTML;
    }
  }

  if (!customElements.get('product-pickup-availability')) {
    customElements.define('product-pickup-availability', ProductPickupAvailability);
  }
})();
